import appDeductionPlan from "../../views/appPlans/deduction.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("deductionplan", {
    url: "deductionplan/:id",
    parent: "app",
    views: {
      view: {
        template: appDeductionPlan,
      },
    },
    reloadOnSearch: false,
    data: { title: "Supply Deduction Plan" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/deductionPlan/deductionPlan.urls.js